import { typeRole } from '@/styles/typography';
import { Minus, Plus } from 'lucide-react';
import { cx } from './cx';

export interface AmountStepperProps {
  value: number;
  onChange: (next: number) => void;
  step?: number;
  min?: number;
  max?: number;
  format?: (v: number) => string;
  className?: string;
}

const defaultFormat = (v: number) =>
  `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Cosmos amount stepper (1d): ± controls around a gold monospace value. */
export default function AmountStepper({
  value,
  onChange,
  step = 5,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  format = defaultFormat,
  className,
}: AmountStepperProps) {
  const dec = () => onChange(Math.max(min, value - step));
  const inc = () => onChange(Math.min(max, value + step));
  const btn =
    'w-10 h-10 inline-flex items-center justify-center rounded-control border border-border-ice bg-white/5 text-ice hover:bg-white/10 transition-colors focus-visible:outline-none focus-visible:shadow-focus-ring disabled:opacity-40';
  return (
    <div className={cx('inline-flex items-center gap-2', className)}>
      <button type="button" aria-label="Decrease amount" className={btn} onClick={dec} disabled={value <= min}>
        <Minus className="w-4 h-4" />
      </button>
      <span className={`min-w-[110px] text-center font-money font-semibold text-money-out-soft tabular-nums ${typeRole.header1}`}>
        {format(value)}
      </span>
      <button type="button" aria-label="Increase amount" className={btn} onClick={inc} disabled={value >= max}>
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
